import { useTranslation, TranslationPhrase } from '@/services/translation';

export function useLocalizedTexts() {
  const { t } = useTranslation();
  const localizedTextsDictionary = {
    datePickerGridHeaderMonText: t(TranslationPhrase.UI_KIT_DATE_PICKER_GRID_HEADER_MON_TEXT),
    datePickerGridHeaderTueText: t(TranslationPhrase.UI_KIT_DATE_PICKER_GRID_HEADER_TUE_TEXT),
    datePickerGridHeaderWedText: t(TranslationPhrase.UI_KIT_DATE_PICKER_GRID_HEADER_WED_TEXT),
    datePickerGridHeaderThuText: t(TranslationPhrase.UI_KIT_DATE_PICKER_GRID_HEADER_THU_TEXT),
    datePickerGridHeaderFriText: t(TranslationPhrase.UI_KIT_DATE_PICKER_GRID_HEADER_FRI_TEXT),
    datePickerGridHeaderSatText: t(TranslationPhrase.UI_KIT_DATE_PICKER_GRID_HEADER_SAT_TEXT),
    datePickerGridHeaderSunText: t(TranslationPhrase.UI_KIT_DATE_PICKER_GRID_HEADER_SUN_TEXT),
    phoneInputPlaceholder: t(TranslationPhrase.UI_KIT_PHONE_INPUT_PLACEHOLDER),
  };
  return localizedTextsDictionary;
}
